export function accordion() {
    const accordionBlock = $(".accordion");
    accordionBlock.on("click", ".heading", function (e) {
        let accordion = $(this).parents(".accordion");
        let parent = $(this).parent();
        if (!parent.hasClass("opened")) {
            setTimeout(() => {
                accordion.find(".accordion-item").removeClass("opened")
                parent.addClass("opened");
                const video = parent.find("video");
                if (video.length && video[0].paused) {
                    video[0].play();
                }
            }, 400);
            accordion.find(".accordion-item").find(".hidden-info").slideUp();
            parent.find(".hidden-info").slideDown();
            accordion.find("video").each(function () {
                $(this)[0].pause();
            });
        }
        e.preventDefault();
    });

    accordionBlock.each(function () {
        const $accordion = $(this);
        const firstItem = $accordion.find(".accordion-item:first-child");
        firstItem.addClass("opened");
        if (firstItem.find("video").length) {
            firstItem.find("video")[0].play();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js